import { render, staticRenderFns } from "./quick-access.vue?vue&type=template&id=4c0a01df&scoped=true&"
import script from "./quick-access.vue?vue&type=script&lang=js&"
export * from "./quick-access.vue?vue&type=script&lang=js&"
import style0 from "./quick-access.vue?vue&type=style&index=0&id=4c0a01df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a01df",
  null
  
)

export default component.exports